import { render, staticRenderFns } from "./LoraParserList.vue?vue&type=template&id=5189379a&scoped=true&"
import script from "./LoraParserList.vue?vue&type=script&lang=ts&"
export * from "./LoraParserList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5189379a",
  null
  
)

export default component.exports